export enum UserRoleEnum {
    SuperAdmin = "superAdmin",
    EntityAdmin = "entityAdmin",
    Professional = "professional",
    Admin = "admin",
}

export class UserRole {
    constructor(
        public readonly id: UserRoleEnum,
        public readonly label: string,
    ) { }
}
